import React from 'react';
import styles from './UserActionSummary.module.scss';

interface UserActionSummaryProps {
  label: string;
  userLabel: string;
  currentBalance: number;
}

export const UserActionSummary: React.FC<UserActionSummaryProps> = ({
  label,
  userLabel,
  currentBalance,
}) => (
  <div className={styles.summary}>
    <div className={styles.summaryLabel}>{label}</div>
    <div className={styles.summaryUser}>{userLabel}</div>
    <div className={styles.summaryBalance}>
      Current balance: {currentBalance.toLocaleString()} credits
    </div>
  </div>
);

export default UserActionSummary;
